<template>
  <div>
    <div class="sku-info-header__wrapper">
      <div class="sku-base-info__wrapper">
        <div class="sku-img__wrapper">
          <el-image
            :src="
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic-square.jpg'
            "
            :preview-src-list="[
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic-square.jpg',
            ]"
            style="width: 120px;height: 120px;"
          >
            <div slot="error" class="image-slot">
              <img src="/image/static/img/nopic-square.jpg" />
            </div>
          </el-image>
        </div>
        <div style="flex:1;">
          <div class="d-flex bt-1 bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('INDEX.form_label_evg_sku_number') || 'SKU Number'
              }}</template>
              <template v-slot>{{ formData.evgSkuNo }}</template>
            </LabelValue>
            <LabelValue style="flex: 0.7 !important;">
              <template v-slot:label>{{
                $l('INDEX.form_label_evgSkuStatus') || 'Status'
              }}</template>
              <template v-slot
                ><b-badge
                  style="font-size: 12px;padding: 5px 10px;"
                  :variant="
                    formData.evgSkuStatus === 'Y'
                      ? 'success'
                      : formData.evgSkuStatus === 'D'
                      ? 'danger'
                      : 'primary'
                  "
                >
                  {{
                    formData.v_evgSkuStatus ||
                      $l('INDEX.title_evg_sku_status_planning') ||
                      '企划'
                  }}
                </b-badge></template
              >
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('INDEX.form_label_evg_sku_last_update') || 'Last update'
              }}</template>
              <template v-slot>
                {{ formData.modifyByName ? formData.modifyByName : '--' }} at
                {{ formData.modifyDate ? formData.modifyDate : '--' }}</template
              >
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('INDEX.form_label_evg_sku_chinese_name') || 'Chinese name'
              }}</template>
              <template v-slot>{{ formData.goodsName }}</template>
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('INDEX.form_label_evg_sku_english_name') || 'English name'
              }}</template>
              <template v-slot>{{ formData.goodsNameEn }}</template>
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('INDEX.form_label_evg_sku_customer') || 'Customer'
              }}</template>
              <template v-slot>{{ formData.custName }}</template>
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('INDEX.form_label_evg_sku_category') || 'Category'
              }}</template>
              <template v-slot>{{ formData.categoryFullName }}</template>
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('INDEX.form_label_evg_sku_brand') || 'Brand'
              }}</template>
              <template v-slot>{{ formData.brandName }}</template>
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('INDEX.form_label_evg_sku_collection') || 'Collection'
              }}</template>
              <template v-slot>{{ formData.collectionName }}</template>
            </LabelValue>
          </div>
        </div>
      </div>
      <SearchTabs v-model="activeName" :newEvgSkuCode="newEvgSkuCode">
      </SearchTabs>
    </div>
    <div v-if="activeName == 'BASE'" class="components--info__wrapper">
      <SkuBase
        ref="skuBase"
        :disabled="disabled"
        :evgSkuCode.sync="newEvgSkuCode"
        :evgSpuCode="evgSpuCode"
        :evgSkuStatus.sync="evgSkuStatus"
        @reload="getData"
      />
      <div class="d-flex justify-content-end mb-2 mt-2" v-if="!disabled">
        <el-button type="primary" size="small" @click="$refs.skuBase.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </div>
    <div v-if="activeName == 'SPEC'" class="components--spec__wrapper">
      <SkuSpec
        :disabled="disabled"
        :isFormal="isFormal"
        :evgSkuCode="newEvgSkuCode"
        :isSingle="isSingle"
        @reload="getData"
      ></SkuSpec>
    </div>
    <div v-if="activeName == 'FABRIC'" class="components--info__wrapper">
      <FabricComposition
        :disabled="disabled || isFormal"
        :evgSkuCode="newEvgSkuCode"
      ></FabricComposition>
    </div>
    <div v-if="activeName == 'Material'" class="components--info__wrapper">
      <MaterialComposition
        :disabled="disabled"
        :isFormal="isFormal"
        :evgSkuCode="newEvgSkuCode"
      ></MaterialComposition>
    </div>
    <div v-if="activeName == 'FTY'" class="components--info__wrapper">
      <SkuScm ref="skuScm" :disabled="disabled" :evgSkuCode="newEvgSkuCode" />
    </div>
    <div v-if="activeName == 'IMG'" class="components--info__wrapper">
      <SkuImage
        ref="skuImage"
        :disabled="disabled"
        :evgSkuCode="newEvgSkuCode"
        @reload="getData"
      />
    </div>
    <div v-if="activeName == 'SALE'" class="components--info__wrapper">
      <SkuPlatform
        ref="skuStore"
        :disabled="disabled || evgSkuStatus === 'Q'"
        :evgSkuCode="newEvgSkuCode"
      />
    </div>
  </div>
</template>
<script>
import SkuBase from '../sku-base'
import SkuImage from '../sku-image'
import SkuScm from '../sku-scm'
import SkuPlatform from '../sku-platform'
import SearchTabs from '../search-tabs'
import SkuSpec from '../sku-spec'
import FabricComposition from '../fabric-composition'
import MaterialComposition from '../material-composition'
import LabelValue from './label-value.vue'
export default {
  components: {
    SkuBase,
    SkuImage,
    SkuPlatform,
    SkuScm,
    SearchTabs,
    SkuSpec,
    FabricComposition,
    MaterialComposition,
    LabelValue,
  },
  props: {
    disabled: { type: Boolean, default: false },
    evgSkuCode: { type: String, default: '' },
    evgSpuCode: { type: String, default: '' },
  },
  data() {
    return {
      activeName: 'BASE',
      evgSkuStatus: '',
      newEvgSkuCode: '',
      formData: {},
    }
  },
  watch: {
    evgSkuCode: {
      handler(e) {
        if (e) this.newEvgSkuCode = e
      },
      immediate: true,
    },
  },
  computed: {
    isSingle() {
      return this.formData.skuPackSize == 'single'
    },
    isFormal() {
      return this.formData.evgSkuStatus == 'Y'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.newEvgSkuCode) return
      let res = await this.$api
        .ecomEvgSkuDetailApi({ evgSkuCode: this.newEvgSkuCode })
        .catch(() => null)
      if (!res) return
      const data = res.body || {}
      this.formData = data
    },
  },
}
</script>
<style lang="scss" scoped>
.sku-info-header__wrapper {
  padding: 16px 16px 0 16px;
  background-color: white;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 10px;
  .sku-base-info__wrapper {
    display: flex;
    margin-bottom: 20px;
    .sku-img__wrapper {
      border: 1px solid #efefef;
      border-right: none;
      width: 130px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.components--info__wrapper {
  background-color: white;
  padding: 15px;
  border-radius: 5px;
}
.components--spec__wrapper {
  background-color: white;
  padding: 15px 15px 50px 15px;
  border-radius: 5px;
}
.bt-1 {
  border-top: 1px solid #efefef;
}
.bb-1 {
  border-bottom: 1px solid #efefef;
}
.bl-1 {
  border-left: 1px solid #efefef;
}
</style>
